/* tslint:disable */
/* eslint-disable */
/**
 * Swagger wiegaaterkoffiehalen
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.3.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InviteAsMember
 */
export interface InviteAsMember {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    email: string;
}

/**
 * Check if a given object implements the InviteAsMember interface.
 */
export function instanceOfInviteAsMember(value: object): value is InviteAsMember {
    if ((!('id' in (value as Record<string, any>)) && !('_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['id'] === undefined && (value as Record<string, any>)['_id'] === undefined)) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function InviteAsMemberFromJSON(json: any): InviteAsMember {
    return InviteAsMemberFromJSONTyped(json, false);
}

export function InviteAsMemberFromJSONTyped(json: any, ignoreDiscriminator: boolean): InviteAsMember {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['_id'],
        'email': json['email'],
    };
}

export function InviteAsMemberToJSON(json: any): InviteAsMember {
    return InviteAsMemberToJSONTyped(json, false);
}

export function InviteAsMemberToJSONTyped(value?: InviteAsMember | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '_id': value['id'],
        'email': value['email'],
    };
}

